import { css } from 'linaria';

export const likeDislikeGroupWrapper = css`
  & > *:first-child {
    margin-right: var(--space-100);
  }
`;
